import { render, staticRenderFns } from "./WeldingMeasurementTab.vue?vue&type=template&id=7838ab9e&scoped=true"
import script from "./WeldingMeasurementTab.vue?vue&type=script&lang=js"
export * from "./WeldingMeasurementTab.vue?vue&type=script&lang=js"
import style0 from "./WeldingMeasurementTab.vue?vue&type=style&index=0&id=7838ab9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7838ab9e",
  null
  
)

export default component.exports